module.exports = __webpack_public_path__ + "img/e_2_5_r.a02783d9.png";